module.exports = __webpack_public_path__ + "img/badge.5d65883f.png";